import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import swal from 'sweetalert';

import { Redirect } from 'react-router-dom';
import Select from 'react-select';
import PageError from '../common_component/PageError.js';
import { Modal } from 'react-bootstrap';
import { setCookie, getCookie } from '../common_component/cookie.js';
import { useTheme } from "./theme-provider.js";
import { useAuthData } from "./auth-provider.js";

function SetUpPaymentConfiguration() {
	let [state, setstate] = useState(2);
	const { theme, dropdownStyleDark } = useTheme();
	const [platform, setPlatform] = useState("Razorpay");
	const [paymentCredentialsSetUpModalShow, setPaymentCredentialsSetUpModalShow] = useState(false)
	const [paymentCredentials, setPaymentCredentials] = useState([]);
	const platformList = ["Razorpay"].map(x => ({ label: x, value: x }));
	const [defaultPaymentAccount, setDefaultPaymentAccount] = useState(false);
	const [contentFlag, setContentFlag] = useState(0);
	const [paymentId, setPaymentId] = useState("");

	const [accountId, setAccountId] = useState("")
	const [apiKey, setApiKey] = useState("")
	const [operationType, setOperationType] = useState("")
	const [secretKey, setSecretKey] = useState("")
	const [mainSubmitButtonState, setMainSubmitButtonState] = useState(false)

	var page_name = "set-up-payment-configuration";

	const { user, read, write, visibility, organization_id } = useAuthData(page_name);

	const loaderstyle = {
		display: "block",
		marginLeft: "auto",
		marginRight: "auto",
		marginTop: "auto",
		marginBottom: "auto",
	};

	useEffect(() => {
		if (read || write) {
			(user.email && visibility) && getPaymentCredentials();
		}
	}, [user, visibility, read, write])

	async function getPaymentCredentials() {
		var object = {};
		object.email = user.email;

		const response = await fetch(
			`${process.env.REACT_APP_SERVER_URL}/fetch-payment-credential`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
		);
		const body = await response.json();
		if (body.operation === "success") {
			setstate(1);
			if (body.data.length > 0) {
				setPaymentCredentials(body.data[0].payment_credentials);
				setPaymentId(body.data[0].unique_id);
				setContentFlag(1);
			}
		}
	}

	const handleEditPaymentConfiguration = (object) => {
		setPaymentCredentialsSetUpModalShow(true)
		setOperationType("Edit")
		setAccountId(object.account_id)
		setApiKey(object.key_id)
		setSecretKey("")
		setDefaultPaymentAccount(object.default);
		setPlatform(object.platform);
	}

	const handleAddPaymentConfiguration = () => {
		setPaymentCredentialsSetUpModalShow(true);
		setOperationType("Add")
		setAccountId(paymentCredentials.length + 1)
		setApiKey("")
		setSecretKey("")
		if (paymentCredentials.find(x => x.default == true) === undefined) {
			setDefaultPaymentAccount(true);
		}
		else {
			setDefaultPaymentAccount(false);
		}
		setPlatform("Razorpay");
	}

	function replaceApiKeys(apiKey) {
		//const middleSection = apiKey.slice(4, -4);
		const newApiKey = apiKey.slice(0, 4) + "..." + apiKey.slice(-4);
		return newApiKey;
	}

	const updateSetupInfo = () => {
		if (apiKey == "") {
			swal("Oops!", "API Key can't be blank", "warning");
			return false;
		}
		if (secretKey == "") {
			swal("Oops!", "Secret Key can't be blank", "warning");
			return false;
		}
		var values = { "payment_id": paymentId, "platform": platform, "operation_type": operationType, "platform": platform, "default_payment_account": defaultPaymentAccount, "account_id": accountId, "api_key": apiKey, "secret_key": secretKey, "page_name": page_name, "organization_id": organization_id };
		setMainSubmitButtonState(true)
		var headers = {
			headers: {
				"Content-Type": "application/json",
				"Accept": "*/*",
				"token": getCookie("access_token")
			}
		}
		let api = `configure-payment-credential`;
		if (contentFlag) {
			api = `update-payment-credential`;
		}

		axios.post(`${process.env.REACT_APP_SERVER_URL}/${api}`, values, headers).then((res) => {
			setMainSubmitButtonState(false)
			if (res.data && res.data.operation == "success") {
				swal("Great!", `Payment credential saved successfully!`, "success").then((value) => {
					setPaymentCredentialsSetUpModalShow(false);
					getPaymentCredentials();
				});
			}
			else {
				swal("Oops!", "Something went wrong!", "error");
			}
		});
	}

	return (
		<>
			<div>
				<div className="d-flex flex-stack mb-5">
					<h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Payment Configuration Info</h1>
					<div className="d-flex align-items-center gap-2 gap-lg-3">
						<a onClick={() => { handleAddPaymentConfiguration() }} className="btn btn-sm btn-primary me-3 rounded btn-hover-scale">
							<span className="d-md-none">
								<svg width="15" height="15" viewBox="0 0 11 11" fill="none">
									<path d="M10.8756 6.56H6.50763V10.856H4.49163V6.56H0.123625V4.664H4.49163V0.344H6.50763V4.664H10.8756V6.56Z" fill="#fff"></path>
								</svg>
							</span>
							<span className="d-none d-md-inline">New Payment Config</span>
						</a>
					</div>
				</div>
				<div>
					{state == 1 ?
						<>
							<div className="card mb-5 mb-xl-8">
								<div className="card-body py-3">
									{paymentCredentials.length > 0 ?
										<div className='overflow-auto w-100 flex-grow-1'>
											<table className="table table-row-bordered text-nowrap table-row-gray-100 align-middle gs-0 gy-3">
												<thead className="border-gray-200 fs-5 fw-semibold bg-lighten">
													<tr>
														<th className="min-w-125px ps-9">Account</th>
														<th className="min-w-100px px-0">Platform</th>
														<th className="min-w-100px px-0">API Key</th>
														<th className="min-w-100px">Secret Key</th>
														<th className="min-w-75px px-0">Default</th>
														<th className="min-w-50px sticky-column" style={{ backdropFilter: 'blur(10px)' }}>Action</th>
													</tr>
												</thead>
												<tbody className="fs-6 fw-semibold text-gray-600">
													{paymentCredentials.map((obj) => {
														return (
															<tr>
																<td className="ps-9">Razorpay {obj.account_id}</td>
																<td className="ps-0"><span className="badge badge-primary">{obj.platform}</span></td>
																<td className="ps-0">{replaceApiKeys(obj.key_id)}</td>
																<td className="ps-0">{obj.secret_key}</td>
																<td className="ps-0">{obj.default ? <span className="badge badge-success">True</span> : <span className="badge badge-secondary">False</span>}</td>
																<td className="sticky-column">
																	<div className='d-flex align-items-center gap-2 gap-lg-3'>
																		<div>
																			<svg width="20" height="20" viewBox="0 0 1024 1024" onClick={() => { handleEditPaymentConfiguration(obj) }}>
																				<g>
																					<path className="cursor-pointer  transparent-most" ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M261.057 569.88l187.155 187.155 436.658-436.663-187.158-187.158-436.656 436.666zM748.456 269.631c11.336 11.336 11.336 29.718 0 41.054l-306.693 306.691c-5.671 5.666-13.098 8.501-20.529 8.501-7.427 0-14.856-2.833-20.525-8.501-11.336-11.339-11.336-29.72 0-41.056l306.691-306.689c11.336-11.336 29.72-11.336 41.056 0z" mi-fill="rgb(115, 208, 244)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M261.057 569.88l187.155 187.155 436.658-436.663-187.158-187.158-436.656 436.666zM748.456 269.631c11.336 11.336 11.336 29.718 0 41.054l-306.693 306.691c-5.671 5.666-13.098 8.501-20.529 8.501-7.427 0-14.856-2.833-20.525-8.501-11.336-11.339-11.336-29.72 0-41.056l306.691-306.689c11.336-11.336 29.72-11.336 41.056 0z" fill="rgb(115, 208, 244)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
																					</path><path className="cursor-pointer  transparent-most" ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M400.709 617.376c5.671 5.668 13.098 8.501 20.525 8.501 7.432 0 14.859-2.835 20.529-8.501l306.693-306.691c11.336-11.339 11.336-29.72 0-41.054-11.334-11.336-29.72-11.336-41.056 0l-306.691 306.689c-11.336 11.339-11.336 29.718 0 41.056z" mi-fill="rgb(61, 104, 137)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M400.709 617.376c5.671 5.668 13.098 8.501 20.525 8.501 7.432 0 14.859-2.835 20.529-8.501l306.693-306.691c11.336-11.339 11.336-29.72 0-41.054-11.334-11.336-29.72-11.336-41.056 0l-306.691 306.689c-11.336 11.339-11.336 29.718 0 41.056z" fill="rgb(61, 104, 137)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
																					</path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M1010.864 185.012c-11.213-33.559-36.041-70.203-71.817-105.969-36.054-36.058-90.955-79.043-147.749-79.043-25.477 0-48.95 8.958-68.065 25.936-0.997 0.764-1.947 1.599-2.845 2.497l-110.135 110.132h-575.388c-16.032 0-29.031 12.998-29.031 29.031v827.374c0 16.032 12.998 29.031 29.031 29.031h827.374c16.032 0 29.031-12.998 29.031-29.031v-593.082c0-1.81-0.189-3.571-0.506-5.288l96.413-96.415c0.194-0.191 0.387-0.38 0.576-0.573 0.005-0.002 0.010-0.007 0.015-0.012l1.889-1.892c0.893-0.893 1.71-1.824 2.46-2.799 26.401-29.614 32.889-67.552 18.746-109.895zM395.108 786.044l-204.828 59.116 46.509-217.434 158.318 158.318zM448.213 757.035l-187.155-187.155 436.656-436.663 187.158 187.158-436.658 436.661zM833.209 965.939h-769.312v-769.312h488.301l-353.392 353.394c-3.96 3.96-6.692 8.98-7.862 14.457l-67.578 315.942c-2.136 9.979 1.13 20.348 8.595 27.308 5.448 5.076 12.546 7.795 19.799 7.795 1.551 0 560.096 0 560.096 0 16.037 0 29.031-12.998 29.031-29.031s-12.994-29.031-29.031-29.031h-354.821l95.237-27.487c4.715-1.362 9.007-3.895 12.478-7.364l368.458-368.458v511.787zM947.853 257.286c-0.317 0.339-0.624 0.685-0.922 1.035l-0.208 0.206c-0.099 0.099-0.203 0.198-0.302 0.298l-20.493 20.491-187.158-187.155 20.965-20.965c0.363-0.307 0.723-0.624 1.072-0.956 8.893-8.308 18.584-12.178 30.492-12.178 28.382 0 67.276 22.61 106.695 62.038 21.594 21.589 89.005 95.29 49.86 137.186z" mi-fill="rgb(61, 104, 137)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M1010.864 185.012c-11.213-33.559-36.041-70.203-71.817-105.969-36.054-36.058-90.955-79.043-147.749-79.043-25.477 0-48.95 8.958-68.065 25.936-0.997 0.764-1.947 1.599-2.845 2.497l-110.135 110.132h-575.388c-16.032 0-29.031 12.998-29.031 29.031v827.374c0 16.032 12.998 29.031 29.031 29.031h827.374c16.032 0 29.031-12.998 29.031-29.031v-593.082c0-1.81-0.189-3.571-0.506-5.288l96.413-96.415c0.194-0.191 0.387-0.38 0.576-0.573 0.005-0.002 0.010-0.007 0.015-0.012l1.889-1.892c0.893-0.893 1.71-1.824 2.46-2.799 26.401-29.614 32.889-67.552 18.746-109.895zM395.108 786.044l-204.828 59.116 46.509-217.434 158.318 158.318zM448.213 757.035l-187.155-187.155 436.656-436.663 187.158 187.158-436.658 436.661zM833.209 965.939h-769.312v-769.312h488.301l-353.392 353.394c-3.96 3.96-6.692 8.98-7.862 14.457l-67.578 315.942c-2.136 9.979 1.13 20.348 8.595 27.308 5.448 5.076 12.546 7.795 19.799 7.795 1.551 0 560.096 0 560.096 0 16.037 0 29.031-12.998 29.031-29.031s-12.994-29.031-29.031-29.031h-354.821l95.237-27.487c4.715-1.362 9.007-3.895 12.478-7.364l368.458-368.458v511.787zM947.853 257.286c-0.317 0.339-0.624 0.685-0.922 1.035l-0.208 0.206c-0.099 0.099-0.203 0.198-0.302 0.298l-20.493 20.491-187.158-187.155 20.965-20.965c0.363-0.307 0.723-0.624 1.072-0.956 8.893-8.308 18.584-12.178 30.492-12.178 28.382 0 67.276 22.61 106.695 62.038 21.594 21.589 89.005 95.29 49.86 137.186z" fill="rgb(61, 104, 137)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
																					</path>
																				</g>
																				<g ng-show="pref.showGrid" className="edit-grid ng-hide">
																					<g className="hLines"></g>
																					<g className="vLines"></g>
																				</g>
																			</svg>
																		</div>
																	</div>
																</td>
															</tr>
														)
													})
													}
												</tbody>
											</table>
										</div>
										:
										<div className="notice d-flex bg-light-primary rounded border-primary border border-dashed rounded-3 p-6">
											<div className="d-flex flex-stack flex-grow-1">
												<div className="fw-bold">
													<h4 className="text-gray-800 fw-bolder">No Data Available.</h4>
													<div className="fs-6 text-gray-600"> </div>
												</div>
											</div>
										</div>
									}
								</div>
							</div>
						</>
						:
						<div className="card modal-body pt-0 pb-15 px-5 px-xl-20">
							{state == 2 ?
								<img src="/images/loader-06.svg" alt="" style={loaderstyle} />
								:
								<PageError />
							}
						</div>
					}
				</div>
			</div>
			<Modal show={paymentCredentialsSetUpModalShow} onHide={() => { }} centered>
				<Modal.Header>
					<Modal.Title>{operationType == "Add" ? <>Add</> : <>Update</>} Razorpay Credential</Modal.Title>
					<div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setPaymentCredentialsSetUpModalShow(false) }}>
						<span className="svg-icon svg-icon-1">
							<svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
								<g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
									<rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
									<rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
								</g>
							</svg>
						</span>
					</div>
				</Modal.Header>
				<Modal.Body>
					<div className='container px-1'>
						<div className="row mb-5">
							<div className="col-12">
								<label className="required fs-5 fw-bold mb-2">Platform</label>
								<Select
									styles={theme === 'dark' ? dropdownStyleDark : {}}
									options={platformList}
									onChange={(val) => { setPlatform(val.value) }}
									value={{ label: platform, value: platform }}
								/>
							</div>
						</div>
						<div className="row mb-5">
							<div className="col-12">
								<label className="required fs-5 fw-bold mb-2">API Key</label>
								<input type="text" className="form-control form-control-solid" value={apiKey} onChange={(e) => { setApiKey(e.target.value) }} placeholder="API Key" />
							</div>
						</div>
						<div className="row mb-5">
							<div className="col-12">
								<label className="required fs-5 fw-bold mb-2">Secret Key</label>
								<input type="text" className="form-control form-control-solid" rows="5" value={secretKey} onChange={(e) => { setSecretKey(e.target.value) }} placeholder="Secret Key" />
							</div>
						</div>
						<div className="row mb-0">
							<label className="col-lg-4 col-form-label fw-bold fs-6">Set As Default</label>
							<div className="col-lg-8 d-flex align-items-center">
								<div className="form-check form-check-solid form-switch form-check-custom fv-row">
									<input className="form-check-input w-45px h-30px" type="checkbox" id="allowmarketing" checked={defaultPaymentAccount} onChange={(e) => { setDefaultPaymentAccount(e.target.checked) }} />
									<label className="form-check-label" for="allowmarketing"></label>
								</div>
							</div>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button className="btn btn-danger rounded" onClick={() => { setPaymentCredentialsSetUpModalShow(false) }}>Close</button>
					{
						write &&
						<button className="btn btn-success rounded" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} onClick={() => { updateSetupInfo() }}>
							<span className="indicator-label">{operationType == "Add" ? <>+ Add</> : <>Update</>}</span>
							<span className="indicator-progress">Please wait...
								<span className="spinner-border spinner-border-sm align-middle ms-2"></span>
							</span>
						</button>
					}
				</Modal.Footer>
			</Modal>
		</>
	);
}

export default SetUpPaymentConfiguration;